import React, { useState, useCallback, useEffect } from 'react';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import Chip from '@mui/material/Chip';
import { styled } from '@mui/styles';
import { createSelector } from 'reselect';
import { useDispatch, useSelector } from 'react-redux';

const WideButton = styled(Button)({
  marginTop: 6,
  marginBottom: 6,
  width: '100%',
});

const WideTextField = styled(TextField)({
  marginTop: 6,
  marginBottom: 6,
  width: '100%',
});

const MarginChip = styled(Chip)({
  marginRight: 4,
  marginBottom: 4,
});

const mapState = createSelector(
  ({ surveyAccounts }) => surveyAccounts,
  (surveyAccounts) => ({ surveyAccounts })
);

export const InviteCollaborators = ({ survey }) => {
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const dispatch = useDispatch();
  const { surveyAccounts: surveyAccountsAll } = useSelector(mapState);
  const surveyAccounts = Object.values(surveyAccountsAll[survey.id] || {});

  useEffect(() => {
    dispatch({
      type: 'FETCH_SURVEY_ACCOUNTS',
      payload: { survey },
    });
  }, [dispatch, survey]);

  const addCollaborator = useCallback(() => {
    // check for matching user
    if (email.indexOf('@') === -1) {
      setError('Email not valid');
      return;
    }

    dispatch({
      type: 'CREATE_SURVEY_ACCOUNT',
      payload: {
        survey,
        account: {
          email,
        },
      },
    });

    setError('');
    setEmail('');
  }, [email, setEmail, setError, dispatch, survey]);

  const removeCollaborator = useCallback(
    (account) => {
      dispatch({
        type: 'DELETE_SURVEY_ACCOUNT',
        payload: {
          survey,
          account,
        },
      });
    },
    [survey, dispatch]
  );

  return (
    <Grid container>
      <Grid item xs={12} container>
        <Typography variant="h6">Invite Collaborators</Typography>
        <Typography variant="body1">
          Collaborators will be able to survey parcels, modify the survey, and
          invite other collaborators.
        </Typography>
      </Grid>
      <br />
      <br />
      <Grid item xs={12}>
        <WideTextField
          placeholder="Collaborator's Email"
          onChange={(e) => setEmail(e.target.value)}
          variant="outlined"
          onKeyDown={(e) => {
            if (e.keyCode === 13) addCollaborator();
          }}
          value={email}
        />
        {error ? <Typography color="secondary">{error}</Typography> : null}
        <WideButton
          onClick={addCollaborator}
          variant="contained"
          color="primary"
          size="large"
        >
          + Add Collaborator
        </WideButton>
      </Grid>
      <br />
      <br />
      {surveyAccounts.map((account) => (
        <Grid item key={account.id}>
          <MarginChip
            label={account.email}
            onDelete={() => removeCollaborator(account)}
          />
          &nbsp;
        </Grid>
      ))}
    </Grid>
  );
};
